import { api } from "../../App";
import { getObjectFromArray } from "../../utils/smallHelpers";
import { SET_SETTINGS_LOADING, SET_SETTINGS_MAIN_DATA } from "../types";



export const getMainData = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_SETTINGS_LOADING, payload: true });
    const { data } = await api.get('/main_options')
    const payload = getObjectFromArray(data.options)
    dispatch({ type: SET_SETTINGS_MAIN_DATA, payload })

  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_SETTINGS_LOADING, payload: false });
  }
};